import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../shared';

/**
 * Refund API - Base definition
 *
 * This is the base API slice for the Refund service.
 * Endpoints are split into separate files and injected using injectEndpoints.
 *
 * @see refundEndpoints.ts - Refund CRUD, worklist, and lookup operations
 * @see documentEndpoints.ts - Document management (upload, download, delete)
 */
export const refundApi = createApi({
  reducerPath: 'refundApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.refunds),
  tagTypes: ['Refund', 'RefundList', 'RefundType', 'RefundPriority', 'RefundWorklist', 'Document'],
  endpoints: () => ({}),
});

